// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3S0j0","boxTitle":"Qualiphy_boxTitle__37t7u","box":"Qualiphy_box__1Y-2u","toggleWrap":"Qualiphy_toggleWrap__32UJv"};